import PuzzleService from '_services/rest/modules/puzzle';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    shapeLinks: null,
    hasChanges: false,
  },
  mutations: {
    setShapeLinks(state, shapeLinks) {
      state.shapeLinks = shapeLinks;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setShapeLinks({ commit }, model) {
      commit('setShapeLinks', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getShapeLinks({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setShapeLinks', response);
          commit('setHasChanges', false);
        })
        .catch(error => {
          handleResourceLoadError(dispatch, error, 'admin-shape-links-list');
        });
    },
  },
};
